import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { CustomButton } from "ui";
import { CancelDraftModal } from "./CancelDrafModal";

export const CancelDraftBtn = observer(() => {
  const { actionModals } = useStores();

  const openDeclineDraftModal = () => {
    actionModals.open(() => <CancelDraftModal />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: "Укажите причину отклонения",
      onApply: () => Promise.resolve(),
    });
  };

  return (
    <CustomButton type="default" tooltip="Отклонить черновик договора" onClick={openDeclineDraftModal}>
      Отклонить черновик
    </CustomButton>
  );
});
